import { connect } from 'react-redux';
import { addEvent, clearRoute, importRoute, editEvent, eventFilterSet, removeEvent, requestPlaceOptions } from '../modules/tour';

import TourRouteTab from './TourRouteTab';

const mapDispatchToProps = {
  clearRoute,
  importRoute,
  addEvent,
  removeEvent,
  editEvent,
  requestPlaceOptions,
  eventFilterSet,
};

const mapStateToProps = state => ({
  tour: state.tours.selectedTour.tour,
  places: state.tours.places,
  filter: state.tours.selectedTour.eventFilter,
});
const TourRouteTabContainer = connect(
    mapStateToProps,
    mapDispatchToProps)(TourRouteTab);
export default TourRouteTabContainer;



// WEBPACK FOOTER //
// src/routes/tours/components/TourRouteTabContainer.js